import {
  INITIAL_STATE_PASSENGER_INGALA,
  REQUEST_FETCH_PASSENGERS_INGALA,
  FETCH_PASSENGERS_INGALA_SUCCESS,
  FETCH_PASSENGERS_INGALA_ERROR,
} from "../../../actions/reservations/passenger/fetchPassengersIngala";

const initialState = {
  passengers: [],
  processing: false,
  fetching: false,
  message: "",
  error: "",
};

const passengerIngalatReducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIAL_STATE_PASSENGER_INGALA: {
      return {
        ...state,
        passengers: [],
        processing: false,
        fetching: false,
        message: "",
        error: "",
      };
    }
    case REQUEST_FETCH_PASSENGERS_INGALA: {
      return {
        ...state,
        passengers: [],
        processing: false,
        fetching: true,
        message: "",
        error: "",
      };
    }
    case FETCH_PASSENGERS_INGALA_SUCCESS: {
      return {
        ...state,
        passengers: action.passengers,
        processing: false,
        fetching: false,
        message: "",
        error: "",
      };
    }
    case FETCH_PASSENGERS_INGALA_ERROR: {
      return {
        ...state,
        passengers: [],
        processing: false,
        fetching: false,
        message: "",
        error: action.error,
      };
    }
    default: {
      return state;
    }
  }
};
export default passengerIngalatReducer;
